import "../style/page/Pharmacyissuelist.scss";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  Pharmacylistissue,
  Pharmacylistissueid,
  sidebar,
} from "../redux/reducer/counterslice";
import { useEffect, useState, useMemo } from "react";
import { pharmacyissuelist, pharmacyissue } from "../../text/apidata";
import BasicTable from "../maincomponent/reacttable/table";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { NavLink } from "react-router-dom";
import noimage1 from "../../assets/images/noimage.png";
import ProductOrderForm from "../form/productorderform";
import Swal from "sweetalert2";

function PharmacyIssueList(props) {
  const [searchQuery, setSearchQuery] = useState("");
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [datacount, setdatacount] = useState();
  const [error, seterror] = useState(false);
  const [popup, setpopup] = useState(false);
  const [id, setid] = useState("");

  const [pharmacyissuelistdata, setpharmacyissuelistdata] = useState({
    report_type: "",
  });
  const [alert, setalert] = useState(false);

  const dispatch = useDispatch();
  const dispatchid = useDispatch();
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const productstate = useSelector((state) => state.counter.Pharmacylistissue);
  const productid = useSelector((state) => state.counter.Pharmacylistissueid);
  const handleSubmit = (event) => {
    event.preventDefault();
  };
  const dropdownhandlechange = (e) => {
    if (e) {
      //   specialitynav("/SpecialityForm");
      dispatch(Pharmacylistissue("pharmacyissuelistedit"));
      dispatchid(Pharmacylistissueid(e));
    }
  };
  useEffect(() => {
    if (searchQuery != "") {
      const hasNumbers = /[0-9]/.test(searchQuery);
      const hasLetters = /[a-zA-Z]/.test(searchQuery);
      const hasSpecialChars = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(
        searchQuery
      );
      if (hasNumbers || hasLetters || hasSpecialChars) {
        axios({
          method: "get",
          url: pharmacyissuelist,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          params: {
            page: dtpageindex,
            page_size: dtpagesize,
            search: searchQuery,
          },
        })
          .then((res) => {
            console.log(res);
            setdatacount(res.data.data_count);
            settableheaderdata(res.data.data);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      axios({
        method: "get",
        url: pharmacyissuelist,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
        params: {
          page: dtpageindex,
          page_size: dtpagesize,
          search: searchQuery,
        },
      })
        .then((res) => {
          console.log(res);
          setdatacount(res.data.data_count);
          settableheaderdata(res.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [dtpageindex, dtpagesize, searchQuery, productstate]);

  useEffect(() => {
    if (productstate == "pharmacyissuelistedit") {
      axios({
        method: "get",
        url: pharmacyissuelist + productid + "/",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
      })
        .then((res) => {
          console.log(res);
          setpharmacyissuelistdata({
            ...pharmacyissuelistdata,
            report_type: res.data.data.report_type,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [productstate]);

  const columns = useMemo(
    () => [
      {
        Header: "Created Date",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.created_date.slice(
                  0,
                  10
                )}
              >
                {row.row.original.created_date.slice(0, 10)}
              </p>
            </>
          );
        },
      },

      {
        Header: "Report Type",
        accessor: "",
        Cell: (row, index) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.report_type}
              >
                {row.row.original.report_type}
              </p>
            </>
          );
        },
      },
      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div class="actions">
                <button
                  type="button"
                  class="btn btn-danger btn-sm edit"
                  onClick={(e) => dropdownhandlechange(row.row.original.id, e)}
                >
                  <i class="bi bi-pencil-fill"></i> Edit
                </button>
              </div>
            </>
          );
        },
      },
    ],
    [popup]
  );

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const Descriptionvalidation = (e) => {
    setalert(true);

    const { name, value } = e.target;
    setpharmacyissuelistdata({
      ...pharmacyissuelistdata,
      [name]: value,
    });
  };

  const newusercreat = (e) => {
    if (pharmacyissuelistdata.report_type != "") {
      if (productstate == "pharmacyissuelistedit") {
        props.loaderchange("true");

        axios({
          method: "put",
          url: pharmacyissuelist + productid + "/",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          data: pharmacyissuelistdata,
        })
          .then((res) => {
            console.log(res);
            dispatch(Pharmacylistissue(""));
            setalert(false);

            setpharmacyissuelistdata({
              ...pharmacyissuelistdata,
              report_type: "",
            });
            seterror(false);
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Pharmacy Issue List Updated Successfully");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          })
          .catch((error) => {
            console.log(error);
            props.loaderchange("true");
            props.popupalert("true");
            props.popuptext(error.response.data.status.message);
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
            props.loaderchange("false");
          });
      } else {
        props.loaderchange("true");

        axios({
          method: "post",
          url: pharmacyissuelist,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          data: pharmacyissuelistdata,
        })
          .then((res) => {
            console.log(res);
            dispatch(Pharmacylistissue(""));
            setalert(false);

            setpharmacyissuelistdata({
              ...pharmacyissuelistdata,
              report_type: res.data.data.report_type,
            });
            seterror(false);
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Pharmacy Issue List Created Successfully");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          })
          .catch((error) => {
            console.log(error);
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext(error.response.data.status.message);
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          });
      }
    } else {
      seterror(true);
    }
  };

  return (
    <>
      <div className={sideactive ? "productorder-sa" : "productorder"}>
        <div class="page-header-PO">
          <div class="row">
            <div class="col-sm-7 col-auto">
              <h3 class="page-title">Issue List</h3>
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    to={"/"}
                    onClick={(e) => {
                      dispatch(sidebar("DashBoard"));
                    }}
                  >
                    Dashboard
                  </NavLink>
                </li>
                <li class="breadcrumb-item active">Issue List</li>
              </ul>
            </div>
            <div class="col-sm-5 col">
              <a
                onClick={(e) => {
                  dispatch(Pharmacylistissue("pharmacyissuelistcreate"));
                  setpharmacyissuelistdata({
                    ...pharmacyissuelistdata,
                    report_type: "",
                  });
                  seterror(false);
                }}
                style={{
                  backgroundColor: "#1b5a90",
                  border: "1px solid #1b5a90",
                  color: "white",
                }}
                data-toggle="modal"
                class="btn btn-primary float-right mt-2"
              >
                Add
              </a>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body" style={{ padding: "1.5rem" }}>
                <form onSubmit={handleSubmit}>
                  <div
                    class="input-group rounded"
                    style={{ width: "250px", height: "40px" }}
                  >
                    <input
                      type="search"
                      class="form-control rounded"
                      aria-label="Search"
                      aria-describedby="search-addon"
                      value={searchQuery}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                      onInput={(e) => {
                        if (e.target.value.length <= "100") {
                          setSearchQuery(e.target.value);
                        } else {
                          e.preventDefault();
                        }
                      }}
                      // onKeyDown={(e)=>{if(e.which=="32"){
                      //   e.preventDefault()
                      // }}}

                      min="0"
                      max="10"
                      label="Search"
                      placeholder="Search..."
                      required
                    />
                    <span
                      class="input-group-text border-0 bg-transparent"
                      id="search-addon"
                    >
                      <i
                        class="bi bi-search"
                        style={{
                          color: "#1b5a90",
                          width: "20px",
                          height: "20px",
                        }}
                      ></i>
                    </span>
                  </div>
                </form>

                <div className="table-responsive">
                  <BasicTable
                    columns={columns}
                    data={tableheaderdata}
                    pagesize={pagesize}
                    pageindex={pageindex}
                    dtpagesize={dtpagesize}
                    dtpageindex={dtpageindex}
                    datacount={datacount}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ReactTooltip
          id="my-tooltip"
          arrowColor="transparent"
          place="bottom-start"
          delayShow={200}
          style={{
            backgroundColor: "#707070",
            fontSize: "10px",
            textAlign: "center",
            padding: "5px",
            fontWeight: 400,
          }}
        />
      </div>
      {productstate == "pharmacyissuelistedit" ||
        productstate == "pharmacyissuelistcreate" ? (
        <>
          <div className="maincontainer">
            <div className="parent-symptomsform">
              <div className="create-symptomsform card">
                <div class="modal-header">
                  <h5 class="modal-title">
                    {productstate == "pharmacyissuelistedit"
                      ? " Issue List Edit"
                      : " Issue List Create"}
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={(e) => {
                      if (alert) {
                        Swal.fire({
                          title: "Are you sure?",
                          text: "You won't be able to revert this!",
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Yes, revert it!",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            // Swal.fire(
                            //   "Deleted!",
                            //   "Given Info has been deleted.",
                            //   "success"
                            // );
                            dispatch(Pharmacylistissue(""));
                            setalert(false);

                            setpharmacyissuelistdata({
                              ...pharmacyissuelistdata,
                              report_type: "",
                            });
                          }
                        });
                      } else {
                        dispatch(Pharmacylistissue(""));
                        setalert(false);

                        setpharmacyissuelistdata({
                          ...pharmacyissuelistdata,
                          report_type: "",
                        });
                      }
                    }}
                  >
                    <i class="bi bi-x-lg"></i>
                  </button>
                </div>
                <div class="modal-body" style={{ padding: "0 !important" }}>
                  <form
                    style={{ padding: "0 1.5rem 0rem" }}
                    className="formspace"
                    onSubmit={handleSubmit}
                  >
                    <div className="from-row">
                      <div className="form-group col-md-12">
                        <label class="form-label">Report Type</label>

                        <textarea
                          type="textarea"
                          class="form-control"
                          id="validationCustom01"
                          name="report_type"
                          value={pharmacyissuelistdata.report_type}
                          style={{ resize: "none" }}
                          onChange={(e) => Descriptionvalidation(e)}
                          onKeyDown={(e) => {
                            if (e.target.value.length === 0 && e.which === 32) {
                              e.preventDefault();
                            }
                          }}
                          rows="3"
                          required
                        ></textarea>
                        {error && pharmacyissuelistdata.report_type == "" && (
                          <p style={{ fontSize: "12px", color: "red" }}>
                            Report Type Required
                          </p>
                        )}
                      </div>
                    </div>

                    <div
                      class="form-row"
                      style={{
                        display: "flex",
                        flexFlow: "row wrap",
                        placeContent: "center space-between",
                        alignItems: "center",
                      }}
                    >
                      <div class="form-group col-md-12">
                        <button
                          type="submit"
                          class="btn btn-primary  create"
                          onClick={(e) => newusercreat(e)}
                          disabled={!alert ? true : false}

                        >
                          {productstate == "pharmacyissuelistedit"
                            ? "Update  Issue List"
                            : " Create  Issue List"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
}

export default PharmacyIssueList;
